/**
 * @generated SignedSource<<955d5131e7f6e05c06828c8d143d29d3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateProfileInput = {
  clientMutationId?: string | null | undefined;
  patch: ProfilePatch;
  rowId: any;
};
export type ProfilePatch = {
  beliefSystemId?: any | null | undefined;
  biography?: string | null | undefined;
  birthdate?: any | null | undefined;
  childrenPreferenceId?: any | null | undefined;
  closestCity?: string | null | undefined;
  createdAt?: any | null | undefined;
  educationLevelId?: any | null | undefined;
  genderId?: any | null | undefined;
  genderOther?: string | null | undefined;
  geolocation?: PointInput | null | undefined;
  heightCm?: number | null | undefined;
  heightFt?: number | null | undefined;
  heightIn?: number | null | undefined;
  instagram?: string | null | undefined;
  name?: string | null | undefined;
  occupation?: string | null | undefined;
  politicalViewId?: any | null | undefined;
  pronounId?: any | null | undefined;
  rowId?: any | null | undefined;
  school?: string | null | undefined;
  updatedAt?: any | null | undefined;
  userId?: any | null | undefined;
  vaccinationStatusId?: any | null | undefined;
};
export type PointInput = {
  x: number;
  y: number;
};
export type UserNavigatorViewUpdateProfileMutation$variables = {
  input: UpdateProfileInput;
};
export type UserNavigatorViewUpdateProfileMutation$data = {
  readonly updateProfile: {
    readonly profile: {
      readonly geolocation: {
        readonly x: number;
        readonly y: number;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type UserNavigatorViewUpdateProfileMutation = {
  response: UserNavigatorViewUpdateProfileMutation$data;
  variables: UserNavigatorViewUpdateProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Point",
  "kind": "LinkedField",
  "name": "geolocation",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "x",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "y",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserNavigatorViewUpdateProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateProfilePayload",
        "kind": "LinkedField",
        "name": "updateProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UserNavigatorViewUpdateProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateProfilePayload",
        "kind": "LinkedField",
        "name": "updateProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7c247b48b1b56ed2742c53550af713f7",
    "id": null,
    "metadata": {},
    "name": "UserNavigatorViewUpdateProfileMutation",
    "operationKind": "mutation",
    "text": "mutation UserNavigatorViewUpdateProfileMutation(\n  $input: UpdateProfileInput!\n) {\n  updateProfile(input: $input) {\n    profile {\n      geolocation {\n        x\n        y\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac40e4d1fc651452e8e751aebc3314fc";

export default node;
